/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * shortsworks
 * 

#ShortsWorksAPIDocs

##버전

헤더에그룹화된태그를추가하는방식으로버저닝을지원합니다.

예시)
```

GET{{host}}/account/signin
headers=[
...
{"x-api-version":"2024-09-01"},
...
]

```

버전리스트
***2024-09-01**(version을적지않으면기본적용되는버전)
***2024-10-16**


 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  Cafe24ShopList,
  DeleteScriptRequestDto,
  GetCafe24AccessTokenParams,
  GetCafe24ProductListParams,
  GetCafe24ThemeListParams,
  GetRedirectCafe24AuthParams,
  HTTPValidationError,
  RegisterScriptRequestDto,
  UpdateScriptRequestDto
} from '.././model'
import { client } from '../../lib/client';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 카페24엑세스토큰체크및리디렉션API
 * @summary DataPass
 */
export const getRedirectCafe24Auth = (
    params: GetRedirectCafe24AuthParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<unknown>(
      {url: `/external/auth/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRedirectCafe24AuthQueryKey = (params: GetRedirectCafe24AuthParams,) => {
    return [`/external/auth/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRedirectCafe24AuthQueryOptions = <TData = Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError = HTTPValidationError>(params: GetRedirectCafe24AuthParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRedirectCafe24AuthQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRedirectCafe24Auth>>> = ({ signal }) => getRedirectCafe24Auth(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRedirectCafe24AuthQueryResult = NonNullable<Awaited<ReturnType<typeof getRedirectCafe24Auth>>>
export type GetRedirectCafe24AuthQueryError = HTTPValidationError


export function useGetRedirectCafe24Auth<TData = Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError = HTTPValidationError>(
 params: GetRedirectCafe24AuthParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRedirectCafe24Auth>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetRedirectCafe24Auth<TData = Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError = HTTPValidationError>(
 params: GetRedirectCafe24AuthParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRedirectCafe24Auth>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetRedirectCafe24Auth<TData = Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError = HTTPValidationError>(
 params: GetRedirectCafe24AuthParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary DataPass
 */

export function useGetRedirectCafe24Auth<TData = Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError = HTTPValidationError>(
 params: GetRedirectCafe24AuthParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRedirectCafe24AuthQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetRedirectCafe24AuthSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError = HTTPValidationError>(params: GetRedirectCafe24AuthParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRedirectCafe24AuthQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRedirectCafe24Auth>>> = ({ signal }) => getRedirectCafe24Auth(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRedirectCafe24AuthSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getRedirectCafe24Auth>>>
export type GetRedirectCafe24AuthSuspenseQueryError = HTTPValidationError


export function useGetRedirectCafe24AuthSuspense<TData = Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError = HTTPValidationError>(
 params: GetRedirectCafe24AuthParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetRedirectCafe24AuthSuspense<TData = Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError = HTTPValidationError>(
 params: GetRedirectCafe24AuthParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetRedirectCafe24AuthSuspense<TData = Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError = HTTPValidationError>(
 params: GetRedirectCafe24AuthParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary DataPass
 */

export function useGetRedirectCafe24AuthSuspense<TData = Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError = HTTPValidationError>(
 params: GetRedirectCafe24AuthParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRedirectCafe24Auth>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRedirectCafe24AuthSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 카페24엑세스토큰체크API
 * @summary SetAccessToken
 */
export const getCafe24AccessToken = (
    params: GetCafe24AccessTokenParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<unknown>(
      {url: `/external/cafe24/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCafe24AccessTokenQueryKey = (params: GetCafe24AccessTokenParams,) => {
    return [`/external/cafe24/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCafe24AccessTokenQueryOptions = <TData = Awaited<ReturnType<typeof getCafe24AccessToken>>, TError = HTTPValidationError>(params: GetCafe24AccessTokenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24AccessToken>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCafe24AccessTokenQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCafe24AccessToken>>> = ({ signal }) => getCafe24AccessToken(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCafe24AccessToken>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCafe24AccessTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getCafe24AccessToken>>>
export type GetCafe24AccessTokenQueryError = HTTPValidationError


export function useGetCafe24AccessToken<TData = Awaited<ReturnType<typeof getCafe24AccessToken>>, TError = HTTPValidationError>(
 params: GetCafe24AccessTokenParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24AccessToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCafe24AccessToken>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24AccessToken<TData = Awaited<ReturnType<typeof getCafe24AccessToken>>, TError = HTTPValidationError>(
 params: GetCafe24AccessTokenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24AccessToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCafe24AccessToken>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24AccessToken<TData = Awaited<ReturnType<typeof getCafe24AccessToken>>, TError = HTTPValidationError>(
 params: GetCafe24AccessTokenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24AccessToken>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary SetAccessToken
 */

export function useGetCafe24AccessToken<TData = Awaited<ReturnType<typeof getCafe24AccessToken>>, TError = HTTPValidationError>(
 params: GetCafe24AccessTokenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24AccessToken>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCafe24AccessTokenQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCafe24AccessTokenSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCafe24AccessToken>>, TError = HTTPValidationError>(params: GetCafe24AccessTokenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24AccessToken>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCafe24AccessTokenQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCafe24AccessToken>>> = ({ signal }) => getCafe24AccessToken(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24AccessToken>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCafe24AccessTokenSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCafe24AccessToken>>>
export type GetCafe24AccessTokenSuspenseQueryError = HTTPValidationError


export function useGetCafe24AccessTokenSuspense<TData = Awaited<ReturnType<typeof getCafe24AccessToken>>, TError = HTTPValidationError>(
 params: GetCafe24AccessTokenParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24AccessToken>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24AccessTokenSuspense<TData = Awaited<ReturnType<typeof getCafe24AccessToken>>, TError = HTTPValidationError>(
 params: GetCafe24AccessTokenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24AccessToken>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24AccessTokenSuspense<TData = Awaited<ReturnType<typeof getCafe24AccessToken>>, TError = HTTPValidationError>(
 params: GetCafe24AccessTokenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24AccessToken>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary SetAccessToken
 */

export function useGetCafe24AccessTokenSuspense<TData = Awaited<ReturnType<typeof getCafe24AccessToken>>, TError = HTTPValidationError>(
 params: GetCafe24AccessTokenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24AccessToken>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCafe24AccessTokenSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 카페24쇼핑몰의상품리스트를가져오는API
 * @summary GetProducts
 */
export const getCafe24ProductList = (
    mallId: string,
    params: GetCafe24ProductListParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<unknown>(
      {url: `/external/cafe24/product/${mallId}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCafe24ProductListQueryKey = (mallId: string,
    params: GetCafe24ProductListParams,) => {
    return [`/external/cafe24/product/${mallId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCafe24ProductListQueryOptions = <TData = Awaited<ReturnType<typeof getCafe24ProductList>>, TError = HTTPValidationError>(mallId: string,
    params: GetCafe24ProductListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCafe24ProductListQueryKey(mallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCafe24ProductList>>> = ({ signal }) => getCafe24ProductList(mallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(mallId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCafe24ProductList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCafe24ProductListQueryResult = NonNullable<Awaited<ReturnType<typeof getCafe24ProductList>>>
export type GetCafe24ProductListQueryError = HTTPValidationError


export function useGetCafe24ProductList<TData = Awaited<ReturnType<typeof getCafe24ProductList>>, TError = HTTPValidationError>(
 mallId: string,
    params: GetCafe24ProductListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ProductList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCafe24ProductList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ProductList<TData = Awaited<ReturnType<typeof getCafe24ProductList>>, TError = HTTPValidationError>(
 mallId: string,
    params: GetCafe24ProductListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ProductList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCafe24ProductList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ProductList<TData = Awaited<ReturnType<typeof getCafe24ProductList>>, TError = HTTPValidationError>(
 mallId: string,
    params: GetCafe24ProductListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetProducts
 */

export function useGetCafe24ProductList<TData = Awaited<ReturnType<typeof getCafe24ProductList>>, TError = HTTPValidationError>(
 mallId: string,
    params: GetCafe24ProductListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCafe24ProductListQueryOptions(mallId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCafe24ProductListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCafe24ProductList>>, TError = HTTPValidationError>(mallId: string,
    params: GetCafe24ProductListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCafe24ProductListQueryKey(mallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCafe24ProductList>>> = ({ signal }) => getCafe24ProductList(mallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(mallId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ProductList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCafe24ProductListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCafe24ProductList>>>
export type GetCafe24ProductListSuspenseQueryError = HTTPValidationError


export function useGetCafe24ProductListSuspense<TData = Awaited<ReturnType<typeof getCafe24ProductList>>, TError = HTTPValidationError>(
 mallId: string,
    params: GetCafe24ProductListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ProductListSuspense<TData = Awaited<ReturnType<typeof getCafe24ProductList>>, TError = HTTPValidationError>(
 mallId: string,
    params: GetCafe24ProductListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ProductListSuspense<TData = Awaited<ReturnType<typeof getCafe24ProductList>>, TError = HTTPValidationError>(
 mallId: string,
    params: GetCafe24ProductListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetProducts
 */

export function useGetCafe24ProductListSuspense<TData = Awaited<ReturnType<typeof getCafe24ProductList>>, TError = HTTPValidationError>(
 mallId: string,
    params: GetCafe24ProductListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCafe24ProductListSuspenseQueryOptions(mallId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 카페24쇼핑몰의스킨리스트를가져오는API
 * @summary GetDesign
 */
export const getCafe24ThemeList = (
    mallId: string,
    params?: GetCafe24ThemeListParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<unknown>(
      {url: `/external/cafe24/design/${mallId}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCafe24ThemeListQueryKey = (mallId: string,
    params?: GetCafe24ThemeListParams,) => {
    return [`/external/cafe24/design/${mallId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCafe24ThemeListQueryOptions = <TData = Awaited<ReturnType<typeof getCafe24ThemeList>>, TError = HTTPValidationError>(mallId: string,
    params?: GetCafe24ThemeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ThemeList>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCafe24ThemeListQueryKey(mallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCafe24ThemeList>>> = ({ signal }) => getCafe24ThemeList(mallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(mallId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCafe24ThemeList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCafe24ThemeListQueryResult = NonNullable<Awaited<ReturnType<typeof getCafe24ThemeList>>>
export type GetCafe24ThemeListQueryError = HTTPValidationError


export function useGetCafe24ThemeList<TData = Awaited<ReturnType<typeof getCafe24ThemeList>>, TError = HTTPValidationError>(
 mallId: string,
    params: undefined |  GetCafe24ThemeListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ThemeList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCafe24ThemeList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ThemeList<TData = Awaited<ReturnType<typeof getCafe24ThemeList>>, TError = HTTPValidationError>(
 mallId: string,
    params?: GetCafe24ThemeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ThemeList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCafe24ThemeList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ThemeList<TData = Awaited<ReturnType<typeof getCafe24ThemeList>>, TError = HTTPValidationError>(
 mallId: string,
    params?: GetCafe24ThemeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ThemeList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetDesign
 */

export function useGetCafe24ThemeList<TData = Awaited<ReturnType<typeof getCafe24ThemeList>>, TError = HTTPValidationError>(
 mallId: string,
    params?: GetCafe24ThemeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ThemeList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCafe24ThemeListQueryOptions(mallId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCafe24ThemeListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCafe24ThemeList>>, TError = HTTPValidationError>(mallId: string,
    params?: GetCafe24ThemeListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ThemeList>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCafe24ThemeListQueryKey(mallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCafe24ThemeList>>> = ({ signal }) => getCafe24ThemeList(mallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(mallId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ThemeList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCafe24ThemeListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCafe24ThemeList>>>
export type GetCafe24ThemeListSuspenseQueryError = HTTPValidationError


export function useGetCafe24ThemeListSuspense<TData = Awaited<ReturnType<typeof getCafe24ThemeList>>, TError = HTTPValidationError>(
 mallId: string,
    params: undefined |  GetCafe24ThemeListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ThemeList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ThemeListSuspense<TData = Awaited<ReturnType<typeof getCafe24ThemeList>>, TError = HTTPValidationError>(
 mallId: string,
    params?: GetCafe24ThemeListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ThemeList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ThemeListSuspense<TData = Awaited<ReturnType<typeof getCafe24ThemeList>>, TError = HTTPValidationError>(
 mallId: string,
    params?: GetCafe24ThemeListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ThemeList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetDesign
 */

export function useGetCafe24ThemeListSuspense<TData = Awaited<ReturnType<typeof getCafe24ThemeList>>, TError = HTTPValidationError>(
 mallId: string,
    params?: GetCafe24ThemeListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ThemeList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCafe24ThemeListSuspenseQueryOptions(mallId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 카페24쇼핑몰의샵정보를가져오는API
 * @summary GetShopInfo
 */
export const getCafe24ShopInfo = (
    mallId: string,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<unknown>(
      {url: `/external/cafe24/shop_info/${mallId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCafe24ShopInfoQueryKey = (mallId: string,) => {
    return [`/external/cafe24/shop_info/${mallId}`] as const;
    }

    
export const getGetCafe24ShopInfoQueryOptions = <TData = Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError = HTTPValidationError>(mallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCafe24ShopInfoQueryKey(mallId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCafe24ShopInfo>>> = ({ signal }) => getCafe24ShopInfo(mallId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(mallId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCafe24ShopInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getCafe24ShopInfo>>>
export type GetCafe24ShopInfoQueryError = HTTPValidationError


export function useGetCafe24ShopInfo<TData = Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError = HTTPValidationError>(
 mallId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCafe24ShopInfo>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ShopInfo<TData = Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCafe24ShopInfo>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ShopInfo<TData = Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetShopInfo
 */

export function useGetCafe24ShopInfo<TData = Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCafe24ShopInfoQueryOptions(mallId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCafe24ShopInfoSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError = HTTPValidationError>(mallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCafe24ShopInfoQueryKey(mallId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCafe24ShopInfo>>> = ({ signal }) => getCafe24ShopInfo(mallId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(mallId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCafe24ShopInfoSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCafe24ShopInfo>>>
export type GetCafe24ShopInfoSuspenseQueryError = HTTPValidationError


export function useGetCafe24ShopInfoSuspense<TData = Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError = HTTPValidationError>(
 mallId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ShopInfoSuspense<TData = Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ShopInfoSuspense<TData = Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetShopInfo
 */

export function useGetCafe24ShopInfoSuspense<TData = Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCafe24ShopInfoSuspenseQueryOptions(mallId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 카페24쇼핑몰의멀티샵리스트를가져오는API
 * @summary GetShopList
 */
export const getCafe24ShopList = (
    mallId: string,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<Cafe24ShopList>(
      {url: `/external/cafe24/shop_list/${mallId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCafe24ShopListQueryKey = (mallId: string,) => {
    return [`/external/cafe24/shop_list/${mallId}`] as const;
    }

    
export const getGetCafe24ShopListQueryOptions = <TData = Awaited<ReturnType<typeof getCafe24ShopList>>, TError = HTTPValidationError>(mallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopList>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCafe24ShopListQueryKey(mallId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCafe24ShopList>>> = ({ signal }) => getCafe24ShopList(mallId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(mallId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCafe24ShopListQueryResult = NonNullable<Awaited<ReturnType<typeof getCafe24ShopList>>>
export type GetCafe24ShopListQueryError = HTTPValidationError


export function useGetCafe24ShopList<TData = Awaited<ReturnType<typeof getCafe24ShopList>>, TError = HTTPValidationError>(
 mallId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCafe24ShopList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ShopList<TData = Awaited<ReturnType<typeof getCafe24ShopList>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCafe24ShopList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ShopList<TData = Awaited<ReturnType<typeof getCafe24ShopList>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetShopList
 */

export function useGetCafe24ShopList<TData = Awaited<ReturnType<typeof getCafe24ShopList>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCafe24ShopListQueryOptions(mallId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCafe24ShopListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCafe24ShopList>>, TError = HTTPValidationError>(mallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopList>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCafe24ShopListQueryKey(mallId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCafe24ShopList>>> = ({ signal }) => getCafe24ShopList(mallId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(mallId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCafe24ShopListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCafe24ShopList>>>
export type GetCafe24ShopListSuspenseQueryError = HTTPValidationError


export function useGetCafe24ShopListSuspense<TData = Awaited<ReturnType<typeof getCafe24ShopList>>, TError = HTTPValidationError>(
 mallId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ShopListSuspense<TData = Awaited<ReturnType<typeof getCafe24ShopList>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ShopListSuspense<TData = Awaited<ReturnType<typeof getCafe24ShopList>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetShopList
 */

export function useGetCafe24ShopListSuspense<TData = Awaited<ReturnType<typeof getCafe24ShopList>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ShopList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCafe24ShopListSuspenseQueryOptions(mallId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 카페24쇼핑몰의특정몰에설치된스크립트리스트를가져오는API
 * @summary GetScript
 */
export const getCafe24ScriptList = (
    mallId: string,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<unknown>(
      {url: `/external/cafe24/script/${mallId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCafe24ScriptListQueryKey = (mallId: string,) => {
    return [`/external/cafe24/script/${mallId}`] as const;
    }

    
export const getGetCafe24ScriptListQueryOptions = <TData = Awaited<ReturnType<typeof getCafe24ScriptList>>, TError = HTTPValidationError>(mallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ScriptList>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCafe24ScriptListQueryKey(mallId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCafe24ScriptList>>> = ({ signal }) => getCafe24ScriptList(mallId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(mallId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCafe24ScriptList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCafe24ScriptListQueryResult = NonNullable<Awaited<ReturnType<typeof getCafe24ScriptList>>>
export type GetCafe24ScriptListQueryError = HTTPValidationError


export function useGetCafe24ScriptList<TData = Awaited<ReturnType<typeof getCafe24ScriptList>>, TError = HTTPValidationError>(
 mallId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ScriptList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCafe24ScriptList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ScriptList<TData = Awaited<ReturnType<typeof getCafe24ScriptList>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ScriptList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCafe24ScriptList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ScriptList<TData = Awaited<ReturnType<typeof getCafe24ScriptList>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ScriptList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetScript
 */

export function useGetCafe24ScriptList<TData = Awaited<ReturnType<typeof getCafe24ScriptList>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCafe24ScriptList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCafe24ScriptListQueryOptions(mallId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCafe24ScriptListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCafe24ScriptList>>, TError = HTTPValidationError>(mallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ScriptList>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCafe24ScriptListQueryKey(mallId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCafe24ScriptList>>> = ({ signal }) => getCafe24ScriptList(mallId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(mallId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ScriptList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCafe24ScriptListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCafe24ScriptList>>>
export type GetCafe24ScriptListSuspenseQueryError = HTTPValidationError


export function useGetCafe24ScriptListSuspense<TData = Awaited<ReturnType<typeof getCafe24ScriptList>>, TError = HTTPValidationError>(
 mallId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ScriptList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ScriptListSuspense<TData = Awaited<ReturnType<typeof getCafe24ScriptList>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ScriptList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCafe24ScriptListSuspense<TData = Awaited<ReturnType<typeof getCafe24ScriptList>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ScriptList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetScript
 */

export function useGetCafe24ScriptListSuspense<TData = Awaited<ReturnType<typeof getCafe24ScriptList>>, TError = HTTPValidationError>(
 mallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCafe24ScriptList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCafe24ScriptListSuspenseQueryOptions(mallId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 카페24쇼핑몰의스크립트업데이트API
 * @summary UpdateScript
 */
export const updateCafe24Script = (
    updateScriptRequestDto: UpdateScriptRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<unknown>(
      {url: `/external/cafe24/script/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateScriptRequestDto
    },
      options);
    }
  


export const getUpdateCafe24ScriptMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCafe24Script>>, TError,{data: UpdateScriptRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCafe24Script>>, TError,{data: UpdateScriptRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCafe24Script>>, {data: UpdateScriptRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  updateCafe24Script(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCafe24ScriptMutationResult = NonNullable<Awaited<ReturnType<typeof updateCafe24Script>>>
    export type UpdateCafe24ScriptMutationBody = UpdateScriptRequestDto
    export type UpdateCafe24ScriptMutationError = HTTPValidationError

    /**
 * @summary UpdateScript
 */
export const useUpdateCafe24Script = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCafe24Script>>, TError,{data: UpdateScriptRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateCafe24Script>>,
        TError,
        {data: UpdateScriptRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateCafe24ScriptMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 카페24쇼핑몰자동스크립트설치API
 * @summary SetScript
 */
export const setCafe24Script = (
    registerScriptRequestDto: RegisterScriptRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<unknown>(
      {url: `/external/cafe24/script/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerScriptRequestDto
    },
      options);
    }
  


export const getSetCafe24ScriptMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCafe24Script>>, TError,{data: RegisterScriptRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof setCafe24Script>>, TError,{data: RegisterScriptRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCafe24Script>>, {data: RegisterScriptRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  setCafe24Script(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetCafe24ScriptMutationResult = NonNullable<Awaited<ReturnType<typeof setCafe24Script>>>
    export type SetCafe24ScriptMutationBody = RegisterScriptRequestDto
    export type SetCafe24ScriptMutationError = HTTPValidationError

    /**
 * @summary SetScript
 */
export const useSetCafe24Script = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCafe24Script>>, TError,{data: RegisterScriptRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof setCafe24Script>>,
        TError,
        {data: RegisterScriptRequestDto},
        TContext
      > => {

      const mutationOptions = getSetCafe24ScriptMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 카페24쇼핑몰의스크립트삭제API
 * @summary DeleteScript
 */
export const deleteCafe24Script = (
    deleteScriptRequestDto: DeleteScriptRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<unknown>(
      {url: `/external/cafe24/script/`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteScriptRequestDto
    },
      options);
    }
  


export const getDeleteCafe24ScriptMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCafe24Script>>, TError,{data: DeleteScriptRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCafe24Script>>, TError,{data: DeleteScriptRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCafe24Script>>, {data: DeleteScriptRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  deleteCafe24Script(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCafe24ScriptMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCafe24Script>>>
    export type DeleteCafe24ScriptMutationBody = DeleteScriptRequestDto
    export type DeleteCafe24ScriptMutationError = HTTPValidationError

    /**
 * @summary DeleteScript
 */
export const useDeleteCafe24Script = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCafe24Script>>, TError,{data: DeleteScriptRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCafe24Script>>,
        TError,
        {data: DeleteScriptRequestDto},
        TContext
      > => {

      const mutationOptions = getDeleteCafe24ScriptMutationOptions(options);

      return useMutation(mutationOptions);
    }
    